<template>
  <v-menu
    lazy
    offset-y
    ref="menu"
    full-width
    v-model="show"
    nudge-bottom="3"
    max-width="290px"
    :left="$vuetify.rtl"
    :disabled="disabled"
    content-class="shadow border"
    transition="scale-transition"
    :return-value.sync="dateValue"
    :close-on-content-click="false"
    :origin="$vuetify.rtl ? 'top right' : 'top left'"
  >
    <v-text-field
      readonly
      :flat="flat"
      :solo="solo"
      :dark="dark"
      id="element"
      :label="label"
      slot="activator"
      :value="dateValue"
      :outline="outline"
      :clearable="clearable"
      @input="changed(null)"
      :single-line="singleLine"
      :hide-details="hideDetails"
      :prepend-icon="prependIcon"
      :error-messages="errorMessages"
      :prepend-inner-icon="prependInnerIcon"
      >{{ value }}</v-text-field
    >
    <v-date-picker
      no-title
      color="primary"
      :min="minDate"
      @input="changed"
      v-model="dateValue"
      class="elevation-0"
      :first-day-of-week="6"
    />
  </v-menu>
</template>
<script>
export default {
  props: {
    label: {
      default: "Date "
    },
    value: {
      default: new Date().toISOString().substring(0, 10)
    },
    disabled: {
      default: false
    },
    clearable: {
      default: false
    },
    minDate: {
      default: null
    },
    dark: {
      default: false
    },
    singleLine: {
      default: false
    },
    solo: {
      default: false
    },
    flat: {
      default: false
    },
    hasIcon: {
      default: false
    },
    outline: {
      default: false
    },
    errorMessages: {
      default: undefined
    },
    hideDetails: {
      default: false
    },
    prependInnerIcon: {
      default: undefined
    },
    prependIcon: {
      default: undefined
    }
  },
  data() {
    return {
      show: false,
      date: ""
    };
  },

  computed: {
    dateValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },

  methods: {
    changed(value) {
      this.$refs.menu.save(value);
      this.$emit("input", value);
      this.$emit("set", value);
    }
  },
  filters: {
    isoDateFilter(date) {
      if (date != null) return date.subString(0, 10);
      return "";
    }
  }
};
</script>
